import { memo } from 'react'
import { Fab, styled } from '@mui/material'
import { PlusIcon } from '$common/icons/plus.jsx'
import { showToolboxModal } from '$comp/modals/toolbox'

const StyledFab = styled(Fab)`
  position: absolute;
  bottom: 12px;
  left: 12px;
`

export const ToolboxFab = memo(() => {
  return (
    <StyledFab color="neutralDark" onClick={showToolboxModal}>
      <PlusIcon sx={{ color: 'inherit' }} />
    </StyledFab>
  )
})
